module.exports = __webpack_public_path__ + "static/media/palette.6a89bca3.svg";